import { useEffect, useRef } from 'react'

/**
 * Canvas starfield. `zoom` is a target scale: >1 zooms out (stars rush toward the centre), animated smoothly.
 * The reveal drives it proportional to how wrong the guess was.
 */
export function Starfield({ zoom = 1 }: { zoom?: number }) {
  const ref = useRef<HTMLCanvasElement>(null)
  const target = useRef(zoom)
  useEffect(() => { target.current = zoom }, [zoom])

  useEffect(() => {
    const c = ref.current!; const ctx = c.getContext('2d')!
    let w = 0, h = 0, raf = 0, cur = 1
    const stars = Array.from({ length: 260 }, () => ({ x: Math.random() * 2 - 1, y: Math.random() * 2 - 1, z: Math.random() * 0.9 + 0.1, s: Math.random() }))
    const resize = () => { w = c.width = innerWidth * devicePixelRatio; h = c.height = innerHeight * devicePixelRatio }
    resize(); addEventListener('resize', resize)
    const draw = () => {
      cur += (target.current - cur) * 0.08
      ctx.clearRect(0, 0, w, h)
      const cx = w / 2, cy = h / 2, R = Math.max(w, h)
      for (const s of stars) {
        // zoom out: each star's apparent position shrinks toward the centre; depth controls parallax
        const k = Math.pow(cur, 0.6 + s.z) 
        const x = cx + (s.x * R * 0.8) / k, y = cy + (s.y * R * 0.8) / k
        const r = (0.6 + s.s * 1.6) * devicePixelRatio * Math.min(1.6, Math.sqrt(k))
        ctx.globalAlpha = 0.15 + s.s * 0.45
        ctx.fillStyle = '#F2F4FF'
        ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill()
      }
      ctx.globalAlpha = 1
      raf = requestAnimationFrame(draw)
    }
    draw()
    return () => { cancelAnimationFrame(raf); removeEventListener('resize', resize) }
  }, [])

  return <canvas ref={ref} className="stars" aria-hidden />
}
